import React,{ lazy,Suspense }        from 'react';
import ReactDOM 					  from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Spinner }                    from './assets/component/initComponent';
import { Provider }               	  from 'react-redux';
//STORE
import store                    	  from './redux/store/store';
import './assets/css/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

const LazyApp = lazy(() => import('./App'));

function MyApp(){
	const theme = createTheme({
		breakpoints: {
			values: {
				xs: 0,
				sm: 600,
				md: 960,
				lg: 1280,
				xl: 1920
			}
		},
		palette: {
			mode: 'light',
			primary: {
				main: '#f75940'
			},
			secondary: {
				main: '#001630'
			},
			text: {
				primary: '#001630'
			},
			error: {
				main: '#FF5630'
			},
			warning: {
				main: '#FFAB00'
			},
			success: {
				main: '#22C55E'
			},
			divider: '#e0e0e0'
		},
		spacing: 8,
		shape: {
			borderRadius: 4
		},
		components: {
			MuiList: {
				dense: true
			},
			MuiMenuItem: {
				dense: true
			},
			MuiTable: {
				size: 'small'
			},
			MuiTooltip: {
				arrow: true
			},
			MuiButton:{
				defaultProps: {
					variant:'contained'
				},
				styleOverrides: {
					root: {
						textTransform:'capitalize',
						fontsize:'13px'
					}
				}
			},
			MuiTab:{
				styleOverrides: {
					root: { textTransform:'capitalize',fontWeight:'normal !important' }
				}
			},
			MuiIconButton: {
				defaultProps: {
					size: 'small'
				}
			},
			MuiFab:{
				defaultProps: {
					size: 'small'
				}
			},
			MuiTextField: {
				defaultProps: {
					fullWidth:true,
					variant:'standard'
				}
			},
			MuiSelect:{
				defaultProps: {
					fullWidth:true,
					variant:'standard'
				}
			},
			MuiCheckbox:{
				defaultProps: {
					size: 'small'
				}
			},
			MuiRadio: {
				defaultProps: {
					size: 'small'
				}
			},
			MuiSwitch: {
				defaultProps: {
					size: 'small'
				}
			},
			MuiInputLabel: {
				defaultProps: {
					margin: 'dense'
				}
			},
			MuiToolbar:{
				styleOverrides: {
					root: {
						minHeight: '35px !important',
						margin:'3px 0px'
					}
				}
			},
			MuiAppBar:{
				styleOverrides: {
					root: {
						backgroundColor: '#FFFFFF',
						color: '#001630'
					}
				}
			}
		}
	});

	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<Suspense fallback={<Spinner/>}>
					<LazyApp />
				</Suspense>
			</ThemeProvider>
		</Provider>
	);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<MyApp />);
